<template>
  <div>
    
    <!--查询到货计划列表、发货计划列表返回字段hazardous（是否危险品：1-是，0-否） 判断如下：当字段为1，押运员相关信息必填，0押运员相关字段隐掉，不需要填。 -->
    <!-- 派普货车提货弹框 -->
    <el-dialog :visible.sync="ordinaryDeliveryDialog" width="95%" @open="openDialog" v-loading="loadingOrdinary" :before-close="CloseordinaryDeliveryDialog">
      <template slot="title">
        <p class="Delivery">{{pickOrArrival?'派车送货':'派车提货'}}
          <span class="total">计划总数：{{ topData.planSun }}</span>
          <span class="total">已编辑{{pickOrArrival?'到货':'提'}}单量：{{ topData.alreadyNum }}</span>
          <span class="total">未编辑{{pickOrArrival?'到货':'提'}}单量：{{ topData.noLadingAmount }}</span>
          <span class="total" v-if="!pickOrArrival">可发金额：{{ topData.canSendMoney }}</span>
          <span class="total" v-if="!pickOrArrival">可发数量：{{ topData.canSendAmount }}</span>
          <span class="msgRed">若资金充足，先使用承兑、后使用现金、最后使用信用的顺序抵扣货款</span>
        </p>
      </template>
      <el-table :data="tableData4" ref="multipleTable" @selection-change="handleSelectionChangeOrdinary">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span> <i class="iTitle">*</i> 车牌号(例: 沪A12345)</span>
          </template>
          <template slot-scope="scope">
            <el-autocomplete
              clearable
              prefix-icon="el-icon-search"
              :class="scope.row.state?'inline-input':''"
              v-model.trim="scope.row.licensePlateNum"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              :trigger-on-focus="false"
              @select="handleSelectCommon"
               @blur="OnlicensePlateNum(scope.row)"
              >
            </el-autocomplete>
            <span v-if="scope.row.state" class="inline-span">车牌号格式有误(例: 沪A12345)</span>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span>挂车车牌(非必填)</span>
          </template>
          <template slot-scope="scope">
            <el-input  clearable maxlength="18" v-model.trim="scope.row.trailerNum" placeholder="请输入" @blur="blurTrailerNum(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column min-width="220px" v-if="showCarrierBusinessName">
          <template slot="header">
            <span> <i class="iTitle" v-if="(paramsObj.hazardous=='1')&&(paramsObj.companyCategory=='TY')">*</i> 承运企业名称</span>
          </template>
          <template slot-scope="scope">
            <el-input  clearable maxlength="18" v-model.trim="scope.row.carrierBusinessName" placeholder="请输入" />
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span> <i class="iTitle">*</i> 司机姓名</span>
          </template>
          <template slot-scope="scope">
            <el-input @blur="inputChange(scope.row)" placeholder="请输入" clearable maxlength="10" v-model.trim="scope.row.driverName"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span> <i class="iTitle">*</i> 数量 </span>
          </template>
          <template slot-scope="scope">
            <el-input type="number" clearable placeholder="请输入" @focus="OnlicensePlateNum(scope.row)" v-model.trim="scope.row.arrivalAmount" @input="OnInput(scope.row)" @blur="OnBlur(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="240px">
          <template slot="header">
            <span> <i class="iTitle">*</i> {{pickOrArrival?'送货':'提货'}}起始日期</span>
          </template>
          <template slot-scope="scope">
            <el-date-picker clearable format="yyyyMMdd" value-format="yyyyMMdd" v-model.trim="scope.row.billLadingDate" type="date" placeholder="选择日期" @blur="dateBlur(scope.row)" :picker-options="pickerOptions">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="240px">
          <template slot="header">
            <span> <i class="iTitle">*</i> {{pickOrArrival?'送货':'提货'}}截止日期</span>
          </template>
          <template slot-scope="scope">
            <el-date-picker clearable format="yyyyMMdd" value-format="yyyyMMdd" v-model.trim="scope.row.billLadingClosingDate" type="date" placeholder="选择日期" @blur="deadLine(scope.row)" :picker-options="pickerOptions">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span> <i class="iTitle">*</i> 手机号</span>
          </template>
          <template slot-scope="scope">
            <el-input clearable maxlength="11" v-model.trim="scope.row.driverPhone" @blur="mobileBlur(scope.row)" placeholder="请输入" />
          </template>
        </el-table-column>
        <el-table-column min-width="220px">
          <template slot="header">
            <span> <i class="iTitle">*</i> 身份证号</span>
          </template>
          <template slot-scope="scope">
            <el-input  clearable maxlength="18" v-model.trim="scope.row.driverIdCardNum" placeholder="请输入" @blur="idBlur(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" v-if="paramsObj.hazardous == '1'">
          <template slot="header">
            <span><i class="iTitle">*</i> 押运员姓名</span>
          </template>
          <template slot-scope="scope">
            <el-input  clearable maxlength="10" v-model.trim="scope.row.escortsName" placeholder="请输入" @blur="inputChange2(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" v-if="paramsObj.hazardous == '1'">
          <template slot="header">
            <span><i class="iTitle">*</i> 押运员手机号</span>
          </template>
          <template slot-scope="scope">
            <el-input  clearable maxlength="11" v-model.trim="scope.row.escortsPhone" placeholder="请输入" @blur="mobileBlur2(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column min-width="220px" v-if="paramsObj.hazardous == '1'">
          <template slot="header">
            <span><i class="iTitle">*</i> 押运员身份证号</span>
          </template>
          <template slot-scope="scope">
            <el-input  clearable maxlength="18" v-model.trim="scope.row.escortsIdCardNum" placeholder="请输入" @blur="idBlur2(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span> <i class="iTitle"></i> 备注</span>
          </template>
          <template slot-scope="scope"> 
            <el-popover v-if="scope.row.comment"  placement="top-start" width="200" trigger="hover" :content="scope.row.comment">
              <el-input slot="reference" type="text" class="t-ellipsis" clearable v-model.trim="scope.row.comment" placeholder="请输入"/>
            </el-popover>
             <el-input v-else slot="reference" type="text" class="t-ellipsis" clearable v-model.trim="scope.row.comment" placeholder="请输入"/>
          </template>
        </el-table-column>
        <template v-if="isCarrier">
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 车辆识别码</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.vin" clearable placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 车辆类型</span>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.vehicleType" clearable placeholder="请选择">
              <el-option v-for="(item, index) in vehicleTypeList" :label="item.label" :value="item.value"
              :key="index"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 运输类型</span>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.transportType" clearable placeholder="请选择">
              <el-option v-for="(item, index) in transportTypeList" :label="item.label" :value="item.value"
              :key="index"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 常规装载品种</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.conventionLoadType" clearable placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 排放标准</span>
          </template>
          <template slot-scope="scope">
            <el-select v-model.trim="scope.row.emissionStandard" clearable placeholder="请选择">
              <el-option v-for="item in emissionStandardList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 荷载量</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.loadWeight" clearable type="number" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 车辆所属公司</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.carBelongTo" clearable placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="240px">
          <template slot="header">
            <span><i class="iTitle">*</i> 罐体安全检查有效期</span>
          </template>
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.safetyValidityPeriod" type="date" clearable format="yyyyMMdd"  placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="240px">
          <template slot="header">
            <span><i class="iTitle">*</i> 行驶证注册日期</span>
          </template>
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.dlRegistrateTime" clearable type="date" format="yyyyMMdd"  placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="240px">
          <template slot="header">
            <span><i class="iTitle">*</i> 行驶证有效期</span>
          </template>
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.licenseValidityPeriod" clearable type="date" format="yyyyMMdd"  placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 燃油类型</span>
          </template>
          <template slot-scope="scope">
           <el-select v-model="scope.row.fuelType" clearable placeholder="请选择">
              <el-option v-for="(item, index) in fuelTypeList" :label="item.label" :value="item.value"
              :key="index"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 车牌颜色</span>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.licensePlateColour" clearable placeholder="请选择">
              <el-option v-for="(item, index) in licensePlateColourList" :label="item.label" :value="item.value"
              :key="index"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle"></i> 车长</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.length" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle"></i> 车宽</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.width" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
         <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle"></i> 车高</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.high" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
         <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 车重</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.weight" type="number" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
         <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle"></i> 排量</span>
          </template>
          <template slot-scope="scope">
           <el-input v-model.trim="scope.row.displacement" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>
         <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle"></i> 功率</span>
          </template>
          <template slot-scope="scope">
           <el-input v-model.trim="scope.row.power" placeholder="请输入" clearable></el-input>
          </template>
        </el-table-column>

        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 行驶证附件</span>
          </template>
          <template slot-scope="scope">
            <el-upload
            @click.native="listClick(scope.row)"
            :action="upload"
            :show-file-list="false"
            :on-success="getLicenseUrlXs"
            ref="uploadllalal"
            :before-upload="onlyImages">
            <img v-if="scope.row.licenseUrlXs" :src="scope.row.licenseUrlXs" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </template>
        </el-table-column>

        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle">*</i> 驾驶证附件</span>
          </template>
          <template slot-scope="scope">
            <el-upload
            @click.native="listClick(scope.row)"
            :action="upload"
            :show-file-list="false"
            :on-success="getLicenseUrlJs"
            ref="uploadllalal"
            :before-upload="onlyImages">
            <img v-if="scope.row.licenseUrlJs" :src="scope.row.licenseUrlJs" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column min-width="200px">
          <template slot="header">
            <span><i class="iTitle"></i> 安全员证附件</span>
          </template>
          <template slot-scope="scope">
            <el-upload
            @click.native="listClick(scope.row)"
            :action="upload"
            :show-file-list="false"
            :on-success="getLicenseUrlAqy"
            ref="uploadllalal"
            :before-upload="onlyImages">
            <img v-if="scope.row.licenseUrlAqy" :src="scope.row.licenseUrlAqy" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </template>
        </el-table-column>
        </template>
        <el-table-column min-width="200px" v-if="pickOrArrival">
          <template slot="header">
            <span>我方磅单毛重</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.otherGrossWeight"  placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" v-if="pickOrArrival">
          <template slot="header">
            <span>我方磅单净重</span> 
            <!-- <i class="iTitle">*</i> -->
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.otherNetWeight"  placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" v-if="pickOrArrival">
          <template slot="header">
            <span>我方磅单皮重</span>
          </template>
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.otherTare"  placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" v-if="pickOrArrival">
          <template slot="header">
            <span>上传图片</span>
          </template>
          <template slot-scope="scope">
            <!-- {{scope.row.weightUrl}} -->
            <el-upload
            class="avatar-uploader"
            @click.native="listClick(scope.row)"
            :action="upload"
            :show-file-list="false"
            :on-success="drivingLicenseUpd"
            ref="uploadllalal"
            :before-upload="onlyImages">
            <img v-if="scope.row.weightUrl" :src="scope.row.weightUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!-- <div class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过4Mb</div> -->
          </template>
        </el-table-column>
      </el-table>
      <template>
        <el-button type="primary" size="mini" v-if="!editOrAdd"  @click="pushOrdinary" >新增一条</el-button>
        <el-button type="info" size="mini" @click="CloseordinaryDeliveryDialog">取消</el-button>
        <el-button type="primary" size="mini" :loading="btnLoading" @click="submitOrdinary">提交</el-button>
        <el-button type="primary" size="mini" v-if="!editOrAdd" @click="delCommonRemove">删除</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// 随机数时间戳
function uniqueId() {
  var a = Math.random,
    b = parseInt;
  return (
    Number(new Date()).toString() + b(10 * a()) + b(10 * a()) + b(10 * a())
  );
}
import { baseGateway } from '@/api/base'
import {emissionStandardList,vehicleTypeList,transportTypeList,fuelTypeList,licensePlateColourList} from "@/components/commonVehicles/columns";
export default {
    props: {
        // 弹框是否打开
        ordinaryDialog: {
            type: Boolean,
            default: false,
        },
        // top 参数 
        paramsObj: {
            type: Object,
        },
        //  新增false  || 编辑 true
        editOrAdd: {
            type: Boolean,
            default: false,
        },
        // //  新增false  || 编辑 true
        // editOrAdd: {
        //     type: Boolean,
        //     default: false,
        // },
        // 提货false  || 到货 true
        pickOrArrival:{
            type: Boolean,
            default: false,
        },
        // 是否承运商（承运商要分危货 普货）
        isCarrier:{
            type: Boolean,
            default: false,
        },
        //承运企业字段
        showCarrierBusinessName:{
            type: Boolean,
            default: false,
        },
    },
  data() {
    return {
      emissionStandardList,vehicleTypeList,transportTypeList,fuelTypeList,licensePlateColourList,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的 ;
        },
      },
      upload:`${baseGateway()}/chem-gateway/chem-loms/file/upload`,
      ordinaryDeliveryDialog: false,//弹框是否打开
      loadingOrdinary: false,//全局加载
      btnLoading:false,
      topData:{},
      // 表格数据
      tableData4: [
        //  licensePlateNum:'',
        //     driverName:'',
        //     arrivalAmount: '',
        //     billLadingDate: '',  //到货起始日期
        //     billLadingClosingDate:'',  //到货截止日期
        //     driverPhone:'',
        //     driverIdCardNum:'',
        //     escortsIdCardNum: "",
        //     escortsName: "",
        //     escortsPhone: "",
        //     comment:'',
        //     state:false,
        //     trailerNum:'',
        //     emissionStandard:'',
        //     weightUrl:'',
        //     otherGrossWeight:null,
        //     otherNetWeight:null,
        //     otherTare:null,
        //     vin:'',//车辆识别码
        //     vehicleType:'',//车辆类型
        //     transportType:'',//运输类型
        //     conventionLoadType:'',//常规装载品种
        //     loadWeight:'',//荷载量
        //     carBelongTo:'',//车辆所属公司
        //     safetyValidityPeriod:'',//罐体安全检查有效期
        //     dlRegistrateTime:'',//行驶证注册日期
        //     licenseValidityPeriod:'',//行驶证有效期
        //     fuelType:'',//燃油类型
        //     licensePlateColour:'',//车牌颜色
        //     length:'',//车长
        //     width:'',//车宽
        //     high:'',//车高
        //     weight:'',//车重
        //     displacement:'',//排量
        //     power:'',//功率
        //     licenseUrlXs:'',//行驶证URL
        //     licenseUrlJs:'',//驾驶证URL
        //     licenseUrlAqy:'',//安全员证UR
      ],
      multipleSelectionOrdinary: [], //普货
      timer:null,//定时器

      isClick:false,
      // 上传 选择的行id
      protectListId:''
    };
  },
  watch: {
    multipleSelectionOrdinary: {
      handler(newV, oldV) {
        // 监听表格数据中哪些是在选中的数组里面，在里面的话就让删除按钮可以点击
        this.tableData4.forEach((item) => {
          item.isChecked = newV.includes(item);
        });
      },
      deep: true,
      immediate: true,
    },
    ordinaryDialog:{ 
        handler(newV, oldV) {
            this.ordinaryDeliveryDialog=true
            if(this.editOrAdd){
                if(this.pickOrArrival){
                    this.getArrivalFromDetail()
                }else{
                    this.getExtractFormDetail()
                }   
            }
        },
    },

  },
  methods: {
    listClick(val){
      this.protectListId=val.id
    },
    //上传成功  行驶证
    drivingLicenseUpd(response, file, fileList) {
      if(response.status == 200){
        this.tableData4.forEach(item=>{
          if(item.id==this.protectListId){
            this.$message.success('上传成功')
            item.weightUrl=response.data
          }
        })
      }else{
        this.$message.error('上传失败')
      }
    },
    // 上传成功   行驶证URL
    getLicenseUrlXs(response, file, fileList){
      // console.log(response);
      if(response.status == 200){
        // this.ruleForm.licenseUrlXs = response.data
        // this.$refs.ruleForm.clearValidate('licenseUrlXs');
        this.tableData4.forEach(item=>{
          if(item.id==this.protectListId){
            this.$message.success('上传成功')
            item.licenseUrlXs=response.data
          }
        })
      }else{
        this.$message.error('上传失败')
      }
    },
    // 上传成功  驾驶证URL
    getLicenseUrlJs(response, file, fileList){
      // console.log(response);
      if(response.status == 200){
        // this.ruleForm.licenseUrlJs = response.data
        // this.$refs.ruleForm.clearValidate('licenseUrlJs');
        this.tableData4.forEach(item=>{
          if(item.id==this.protectListId){
            this.$message.success('上传成功')
            item.licenseUrlJs=response.data
          }
        })
      }else{
        this.$message.error('上传失败')
      }
    },
    // 上传成功  安全员证URL
    getLicenseUrlAqy(response, file, fileList){
      // console.log(response);
      if(response.status == 200){
        // this.ruleForm.licenseUrlAqy = response.data
        this.tableData4.forEach(item=>{
          if(item.id==this.protectListId){
            this.$message.success('上传成功')
            item.licenseUrlAqy=response.data
          }
        })
      }else{
        this.$message.error('上传失败')
      }
    },
    //只能上传图片
    onlyImages(file){
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' //image/png
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error('只能上传文件格式为jpeg,png的!');
      }else if (!isLt2M) {
        this.$message.error('上传图片大小不能超过10MB!');
      }else{
        this.$message({
          message: '正在上传中...',
          type:'info',
          duration: 2000
        });
        // this.$message.info('正在上传文件中');
      }
      return isJPG && isLt2M;
    },
    // 获取提单详情
    getExtractFormDetail(){
        this.$api.carrier.postExtractFormDetail({ billLadingNum:this.paramsObj.billLadingNum}).then((res)=>{
            if(res.status==200){
              // console.log(res,441444);
                if(res.data.licensePlateNum){
                  let licensePlateNum=res.data.licensePlateNum
                    if(res.data.licensePlateNum.indexOf('-')!=-1){
                      res.data.licensePlateNum=licensePlateNum.slice(0,licensePlateNum.indexOf('-'))
                      res.data.trailerNum=licensePlateNum.slice(licensePlateNum.indexOf('-')+1)
                    }
                 }
                // 普货
                Object.keys(this.tableData4[0]).forEach(item => {
                  // console.log(item);
                  this.tableData4[0][item] = res.data[item]
                })

                this.tableData4[0].id = uniqueId()
                this.tableData4[0].isChecked = false
            
                this.getdisabled(res.data.planEndDate)
            }
        })
    },

    // 获取到货单详情
    getArrivalFromDetail(){
        this.$api.carrier.postArrivalFromDetail({ arrivalFormNum:this.paramsObj.arrivalFormNum}).then((res)=>{
            if(res.status==200){
                 res.data.billLadingClosingDate=res.data.arrivalClosingDate
                 res.data.billLadingDate=res.data.arrivalDate
                //  console.log(res);
                 if(res.data.licensePlateNum){
                  let licensePlateNum=res.data.licensePlateNum
                    if(res.data.licensePlateNum.indexOf('-')!=-1){
                      res.data.licensePlateNum=licensePlateNum.slice(0,licensePlateNum.indexOf('-'))
                      res.data.trailerNum=licensePlateNum.slice(licensePlateNum.indexOf('-')+1)
                    }
                 }
                // 普货
                Object.keys(this.tableData4[0]).forEach(item => {
                  // console.log(item);
                  if(item!='otherGrossWeight'&&item!='weightUrl'&&item!='otherNetWeight'&&item!='otherTare'){
                    this.tableData4[0][item] = res.data[item]
                  }
                })

                this.tableData4[0].id = uniqueId()
                this.tableData4[0].isChecked = false
                // console.log(this.tableData4[0]);
                this.getdisabled(res.data.planEndDate)
            }
        })
    },
    getdisabled(date) {
      let data1= date.slice(0, 4) + '-' + date.slice(4)
      let data2= data1.slice(0, 7) + '-' + data1.slice(7)
      // console.log(data2)
      this.pickerOptions= Object.assign({},this.pickerOptions,{
         disabledDate(time){
         return  Date.now() - 8.64e7 > time.getTime() || time.getTime() > new Date(data2).getTime();  //如果date格式是2020-7-23或者2020/7/23。这里还是需要转成时间戳。把date改成new Date(date).getTime()
         }
      })
    
    },
    // 新增
    pushOrdinary() {
      let newMultipleSelectionOrdinary = this.deepCopy(
        this.multipleSelectionOrdinary
      );
      newMultipleSelectionOrdinary.forEach((item) => {
        item.id = uniqueId();
      });
      // console.log(newMultipleSelectionOrdinary);
      newMultipleSelectionOrdinary.length > 0? this.tableData4.push(...newMultipleSelectionOrdinary): this.tableData4.push({
            id: uniqueId(),
            licensePlateNum: "",
            trailerNum:'',
            emissionStandard:'',
            carrierBusinessName: "",//承运企业名称
            driverName: "",
            arrivalAmount: "",
            billLadingDate: "", //到货起始日期
            billLadingClosingDate: "", //到货截止日期
            driverPhone: "",
            driverIdCardNum: "",
            escortsIdCardNum: "",
            escortsName: "",
            escortsPhone: "",
            comment: "",
            isChecked: false,
            state:false,
            weightUrl:'',
            otherGrossWeight:'',
            otherNetWeight:'',
            otherTare:'',
            vin:'',//车辆识别码
            vehicleType:'',//车辆类型
            transportType:'',//运输类型
            conventionLoadType:'',//常规装载品种
            loadWeight:'',//荷载量
            carBelongTo:'',//车辆所属公司
            safetyValidityPeriod:'',//罐体安全检查有效期
            dlRegistrateTime:'',//行驶证注册日期
            licenseValidityPeriod:'',//行驶证有效期
            fuelType:'',//燃油类型
            licensePlateColour:'',//车牌颜色
            length:'',//车长
            width:'',//车宽
            high:'',//车高
            weight:'',//车重
            displacement:'',//排量
            power:'',//功率
            licenseUrlXs:'',//行驶证URL
            licenseUrlJs:'',//驾驶证URL
            licenseUrlAqy:'',//安全员证UR
          });
    },
    // 深拷贝
    deepCopy(obj) {
      // console.log(obj);
      // 只拷贝对象
      if (typeof obj !== "object") return;
      // 根据obj的类型判断是新建一个数组还是一个对象
      var newObj = obj instanceof Array ? [] : {};
      for (var key in obj) {
        // 遍历obj,并且判断是obj的属性才拷贝
        if (obj.hasOwnProperty(key)) {
          // 判断属性值的类型，如果是对象递归调用深拷贝
          newObj[key] =
            typeof obj[key] === "object" ? this.deepCopy(obj[key]) : obj[key];
        }
      }
      return newObj;
    },
    // 派车提交
    submitOrdinary() {
        if (this.multipleSelectionOrdinary.length <= 0)return this.$message.warning("请选择一条数据");
        let infoObj = this.multipleSelectionOrdinary;
        let err = "";
        // console.log(infoObj);
        infoObj.some((item,index) => {
          // if(this.pickOrArrival){
            // console.log(index);
            if(!item.licensePlateNum){
              return (err = `请填写第${index+1}行的车牌号`);
            }
            if((!item.carrierBusinessName)&&(this.showCarrierBusinessName)&&(this.paramsObj.hazardous=='1')&&(this.paramsObj.companyCategory=='TY')){
              return (err = `请填写第${index+1}行的承运企业名称`);
            }
            if(!item.driverName){
              return (err = `请填写第${index+1}行的司机姓名`);
            }
            if(!item.arrivalAmount){
              return (err = `请填写第${index+1}行的数量`);
            }
            if(!item.billLadingDate){
              return (err = `请填写第${index+1}行的起始日期`);
            }
            if(!item.billLadingClosingDate){
              return (err = `请填写第${index+1}行的截止日期`);
            }
            if(!item.driverPhone){
              return (err = `请填写第${index+1}行的手机号`);
            }
            if(!item.driverIdCardNum){
              return (err = `请填写第${index+1}行的身份证号`);
            }
            if(this.paramsObj.hazardous == '1'){
              if(!item.escortsName){
                return (err = `请填写第${index+1}行的押运员姓名`);
              }
              if(!item.escortsPhone){
                return (err = `请填写第${index+1}行的押运员手机号`);
              }
              if(!item.escortsIdCardNum){
                return (err = `请填写第${index+1}行的押运员身份证号`);
              }
            }
            if(this.isCarrier){
              if(!item.vin){
                return (err = `请填写第${index+1}行的车辆识别码`);
              }
              if(!item.vehicleType){
                return (err = `请选择第${index+1}行的车辆类型`);
              }
              if(!item.transportType){
                return (err = `请选择第${index+1}行的运输类型`);
              }
              if(!item.conventionLoadType){
                return (err = `请填写第${index+1}行的常规装载品种`);
              }
              if(!item.emissionStandard){
                return (err = `请选择第${index+1}行的排放标准`);
              }
              if(!item.loadWeight){
                return (err = `请填写第${index+1}行的荷载量`);
              }
              if(!item.carBelongTo){
                return (err = `请填写第${index+1}行的车辆所属公司`);
              }
              if(this.paramsObj.hazardous == '1'&&!item.safetyValidityPeriod){
                return (err = `请填写第${index+1}行的罐体安全检查有效期`);
              }
              if(!item.dlRegistrateTime){
                return (err = `请填写第${index+1}行的行驶证注册日期`);
              }
              if(!item.licenseValidityPeriod){
                return (err = `请填写第${index+1}行的行驶证有效期`);
              }
              if(!item.fuelType){
                return (err = `请选择第${index+1}行的燃油类型`);
              }
              if(!item.licensePlateColour){
                return (err = `请选择第${index+1}行的车牌颜色`);
              }
              if(!item.weight){
                return (err = `请填写第${index+1}行的车重`);
              }
              if(!item.licenseUrlXs){
                return (err = `请上传第${index+1}行的 行驶证附件`);
              }
              if(!item.licenseUrlJs){
                return (err = `请上传第${index+1}行的驾驶证附件`);
              }
            }
           
            
            // if (!item.licensePlateNum ||!item.driverName ||!item.arrivalAmount || !item.billLadingDate ||!item.billLadingClosingDate ||!item.driverPhone ||!item.driverIdCardNum ||!item.vin||!item.vehicleType||!item.transportType||!item.conventionLoadType||!item.emissionStandard||!item.loadWeight||!item.carBelongTo||!item.safetyValidityPeriod||!item.dlRegistrateTime||!item.licenseValidityPeriod||!item.fuelType||!item.licensePlateColour||!item.weight||!item.licenseUrlXs||!item.licenseUrlJs) {
            //   return (err = "请查看表格内容是否完整");
            // }
        });
        let sumCount = infoObj.reduce((sum, item) => {
            return sum + item.arrivalAmount;
        }, 0);
        if (err) {
            this.$message.warning(err);
            return;
        }
         this.btnLoading = true;
        //  console.log(this.paramsObj);
        //  return
        if(this.editOrAdd){
            let paramsData = {
                formNum:this.pickOrArrival?this.paramsObj.arrivalFormNum:this.paramsObj.billLadingNum,
                planNum: this.pickOrArrival?this.paramsObj.arrivalPlanNum:this.paramsObj.sendPlanNum,
                ...this.multipleSelectionOrdinary[0],
                documentType: this.pickOrArrival?'02':"01", //到货02  提货01,
                isDanger: '02',//	是否危化车 01: 危货, 02: 普货
            };
            if(this.pickOrArrival){
                paramsData.arrivalClosingDate=paramsData.billLadingClosingDate,
                paramsData.arrivalDate=paramsData.billLadingDate
            }
            if(paramsData.trailerNum&&paramsData.licensePlateNum.indexOf('-')==-1){
              paramsData.licensePlateNum=paramsData.licensePlateNum+'-'+paramsData.trailerNum    
            }
             if (this.paramsObj.hazardous == '1') {
                paramsData.isDanger = "01";
              } else {
                paramsData.isDanger = "02";
              }
            paramsData.otherGrossWeight=paramsData.otherGrossWeight==null?'':paramsData.otherGrossWeight
            paramsData.otherNetWeight=paramsData.otherNetWeight==null?'':paramsData.otherNetWeight
            paramsData.otherTare=paramsData.otherTare==null?'':paramsData.otherTare

            paramsData.safetyValidityPeriod=paramsData.safetyValidityPeriod==null?'' : paramsData.safetyValidityPeriod
            if(this.isCarrier){
              paramsData.isCarrier='1'
            }else{
              paramsData.isCarrier='0'
              paramsData.transportType=this.paramsObj.hazardous
            }

            this.$api.carrier.patchUpdate(paramsData).then((res) => {
                this.btnLoading=false
                // console.log("普货车提交接口", res);
                if (res.status == 200) {
                  this.$message.success(res.msg);
                  this.CloseordinaryDeliveryDialog('edit')
                } else if (res.status == 400) {
                    res.msg=res.msg.replace('<B>','')
                    res.msg=res.msg.replace('</B>','')
                    this.$message.warning(res.msg)
                }
                
            });
        }else{
            if(this.pickOrArrival){
              this.multipleSelectionOrdinary.forEach(item=>{
                  item.arrivalClosingDate=item.billLadingClosingDate
                  item.arrivalDate=item.billLadingDate
              })
            }
            let dataVal=[...this.multipleSelectionOrdinary]
            dataVal.forEach(item=>{
              if(item.trailerNum&&item.licensePlateNum.indexOf('-')==-1){
                item.licensePlateNum=item.licensePlateNum+'-'+item.trailerNum    
              }
              item.otherGrossWeight= item.otherGrossWeight==null?'' : item.otherGrossWeight
              item.otherNetWeight= item.otherNetWeight==null?'' : item.otherNetWeight
              item.otherTare= item.otherTare==null?'' : item.otherTare
              item.safetyValidityPeriod=item.safetyValidityPeriod==null?'' : item.safetyValidityPeriod
            })
            let paramsData = {
                planNum: this.pickOrArrival?this.paramsObj.arrivalPlanNum:this.paramsObj.sendPlanNum,//到货计划号/提货计划号
                list: dataVal,
                documentType:this.pickOrArrival?'02':"01", //单据类型 到货02  提货01
                isDanger: "02",//	是否危化车 01: 危货, 02: 普货
            };
            // return
            let urlPath=''
            // 承运商 要分 危货和普货
            if(this.isCarrier){
              paramsData.isCarrier='1'
              if (this.paramsObj.hazardous == '1') {
                paramsData.isDanger = "01";
                urlPath=this.$api.carrier.postAddDanger(paramsData)
              } else {
                paramsData.isDanger = "02";
                urlPath=this.$api.carrier.postAdd(paramsData)
              }
            }else{
              paramsData.isCarrier='0'
              paramsData.transportType=this.paramsObj.hazardous
              urlPath=this.$api.carrier.postAdd(paramsData)
            }
            if(!this.pickOrArrival) paramsData.noLadingAmount=this.topData.noLadingAmount//未编辑到货单量

            urlPath.then((res) => {
                this.btnLoading = false;
                // console.log("普货车提交接口", res);
                if (res.status == 200) {
                    // this.$message.success(
                    // `${this.paramsObj.sendPlanNum}计划号到货单创建成功，请前往详情查看`
                    // );
                    this.$message.success('创建成功')
                    this.CloseordinaryDeliveryDialog('add');
                } else if (res.status == 400) {
                    this.$message.warning(res.msg);
                }
                
            });
        }
      

    },
    // 删除数据--普货
    delCommonRemove() {
      this.multipleSelectionOrdinary.forEach((v) => {
        this.tableData4 = this.tableData4.filter((y) => {
          return v.id != y.id;
        });
      });
    },
    // 打开弹框(普货)  查询剩余计划量
    openDialog() {
    // console.log(this.paramsObj);
      // 查询剩余计划量
      this.loadingOrdinary = true;
      this.$api.carrier.postLeftCount({ 
        planNum:this.pickOrArrival?this.paramsObj.arrivalPlanNum:this.paramsObj.sendPlanNum,
        type:this.pickOrArrival?'01':'02',//提货02  到货01
       }).then((res) => {
        //   console.log("查询剩余计划量", res)
        this.loadingOrdinary = false;
          if (res.status == 200) {
            this.topData=res.data
          }
      });
      this.tableData4=[
        {
        id: uniqueId(),
        licensePlateNum:'',
        carrierBusinessName: "",
        driverName:'',
        arrivalAmount: '',
        billLadingDate: this.paramsObj.planStartDate,  //到货起始日期
        billLadingClosingDate: this.paramsObj.planEndDate,  //到货截止日期
        driverPhone:'',
        driverIdCardNum:'',
        escortsIdCardNum: "",
        escortsName: "",
        escortsPhone: "",
        comment:'',
        trailerNum:'',
        emissionStandard:'',
        state:false,
        weightUrl:'',
        otherGrossWeight:'',
        otherNetWeight:'',
        otherTare:'',
        vin:'',//车辆识别码
        vehicleType:'',//车辆类型
        transportType:'',//运输类型
        conventionLoadType:'',//常规装载品种
        loadWeight:'',//荷载量
        carBelongTo:'',//车辆所属公司
        safetyValidityPeriod:'',//罐体安全检查有效期
        dlRegistrateTime:'',//行驶证注册日期
        licenseValidityPeriod:'',//行驶证有效期
        fuelType:'',//燃油类型
        licensePlateColour:'',//车牌颜色
        length:'',//车长
        width:'',//车宽
        high:'',//车高
        weight:'',//车重
        displacement:'',//排量
        power:'',//功率
        licenseUrlXs:'',//行驶证URL
        licenseUrlJs:'',//驾驶证URL
        licenseUrlAqy:'',//安全员证UR
        }
      ]
    },
    // 取消-关闭弹框（普货）
    CloseordinaryDeliveryDialog(val) {
      this.multipleSelectionOrdinary.forEach((item) => {
        for (let i in item) {
          item[i] = "";
        }
      });
       this.tableData4=[
            {
            id: uniqueId(),
            licensePlateNum:'',
            carrierBusinessName: "",
            driverName:'',
            arrivalAmount: '',
            billLadingDate: '',  //到货起始日期
            billLadingClosingDate:'',  //到货截止日期
            driverPhone:'',
            driverIdCardNum:'',
            escortsIdCardNum: "",
            escortsName: "",
            escortsPhone: "",
            comment:'',
            state:false,
            trailerNum:'',
            emissionStandard:'',
            weightUrl:'',
             otherGrossWeight:'',
            otherNetWeight:'',
            otherTare:'',
            vin:'',//车辆识别码
            vehicleType:'',//车辆类型
            transportType:'',//运输类型
            conventionLoadType:'',//常规装载品种
            loadWeight:'',//荷载量
            carBelongTo:'',//车辆所属公司
            safetyValidityPeriod:'',//罐体安全检查有效期
            dlRegistrateTime:'',//行驶证注册日期
            licenseValidityPeriod:'',//行驶证有效期
            fuelType:'',//燃油类型
            licensePlateColour:'',//车牌颜色
            length:'',//车长
            width:'',//车宽
            high:'',//车高
            weight:'',//车重
            displacement:'',//排量
            power:'',//功率
            licenseUrlXs:'',//行驶证URL
            licenseUrlJs:'',//驾驶证URL
            licenseUrlAqy:'',//安全员证UR
            }
        ]
      this.ordinaryDeliveryDialog = false;
      if(val=='edit'||val=='add'){ 
        this.$emit('dialogClose',val)
      }
    },
    handleSelectionChangeOrdinary(val) {
      this.multipleSelectionOrdinary = val;
      let sumCout = this.multipleSelectionOrdinary.reduce((total, item) => {
        return total + Number(item.arrivalAmount);
      }, 0);
      if (sumCout > this.topData.noLadingAmount) {
        this.$message.warning("您当前编辑提单量已大于可编辑提单量，请重新输入");
        this.multipleSelectionOrdinary.forEach((item) => {
          item.arrivalAmount = "";
        });
      }
    },
    // 普货
    // 车辆输入建议的方法
    querySearch(queryString, cb) {
        let _this=this
       this.timer = setTimeout(() => {
        _this.$api.carrier.postSelect({licensePlateNum: queryString,page: 1, size: 10,}).then((res) => {
            let cars = res.data.information;
            cars.forEach((item) => {
              item.value = item.licensePlateNum;
            });
            // 调用 callback 返回建议列表的数据
            cb(cars);
          });
      }, 1000);
    },
    // 下拉框选择
    handleSelectCommon(val) {
        // console.log(val);
      this.tableData4.forEach((item) => {
        if (item.licensePlateNum == val.licensePlateNum) {
          if(item.licensePlateNum.indexOf('-')!=-1){
            item.licensePlateNum=item.licensePlateNum.slice(0,item.licensePlateNum.indexOf('-'))
          }
          this.OnlicensePlateNum(item)
          item.driverName = val.driverName
          item.driverPhone = val.driverPhone
          item.driverIdCardNum = val.driverIdCard
          item.arrivalAmount = ""
          item.comment = ""

          item.trailerNum=val.trailerNum||''
          item.emissionStandard=val.emissionStandard||''
          item.id = uniqueId()
          item.weightUrl=''
          item.otherGrossWeight=''
          item.otherNetWeight=''
          item.otherTare=''

          // if(this.paramsObj.hazardous=='1'){
            item.escortsIdCardNum= val.escortsIdCardNum||""
            item.escortsName= val.escortsName||""
            item.escortsPhone= val.escortsPhone||""
          // }
          // else{
          //   item.escortsIdCardNum= ""
          //   item.escortsName= ""
          //   item.escortsPhone= ""
          // }
         
          // if(this.isCarrier){
            item.vin=val.vin//车辆识别码
            item.vehicleType=val.vehicleType//车辆类型
            item.transportType=val.transportType//运输类型
            item.conventionLoadType=val.conventionLoadType//常规装载品种
            item.loadWeight=val.loadWeight//荷载量
            item.carBelongTo=val.carBelongTo//车辆所属公司
            item.safetyValidityPeriod=val.safetyValidityPeriod//罐体安全检查有效期
            item.dlRegistrateTime=val.dlRegistrateTime//行驶证注册日期
            item.licenseValidityPeriod=val.licenseValidityPeriod//行驶证有效期
            item.fuelType=val.fuelType//燃油类型
            item.licensePlateColour=val.licensePlateColour//车牌颜色
            item.length=val.length//车长
            item.width=val.width//车宽
            item.high=val.high//车高
            item.weight=val.weight//车重
            item.displacement=val.displacement//排量
            item.power=val.power//功率
            item.licenseUrlXs=val.licenseUrlXs//行驶证URL
            item.licenseUrlJs=val.licenseUrlJs//驾驶证URL
            item.licenseUrlAqy=val.licenseUrlAqy//安全员证UR
          // }else{
          //   item.vin=""//车辆识别码
          //   item.vehicleType=""//车辆类型
          //   item.transportType=""//运输类型
          //   item.conventionLoadType=""//常规装载品种
          //   item.loadWeight=""//荷载量
          //   item.carBelongTo=""//车辆所属公司
          //   item.safetyValidityPeriod=""//罐体安全检查有效期
          //   item.dlRegistrateTime=""//行驶证注册日期
          //   item.licenseValidityPeriod=""//行驶证有效期
          //   item.fuelType=""//燃油类型
          //   item.licensePlateColour=""//车牌颜色
          //   item.length=""//车长
          //   item.width=""//车宽
          //   item.high=""//车高
          //   item.weight=""//车重
          //   item.displacement=""//排量
          //   item.power=""//功率
          //   item.licenseUrlXs=""//行驶证URL
          //   item.licenseUrlJs=""//驾驶证URL
          //   item.licenseUrlAqy=""//安全员证UR
          // }
        

        }
      });   
      clearTimeout(this.timer);
    },
    // 车牌号 校验
    OnlicensePlateNum(val) {
      // console.log(val.licensePlateNum);
      let reg =/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
      let xreg =/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$)|([A-Z]{2}[0-9]{4}$))/;
      let reg1 =/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{5}[A-Z]{1}$)/;
      // console.log(reg.test(val.licensePlateNum));
      if (!reg.test(val.licensePlateNum)&&!xreg.test(val.licensePlateNum)&&!reg1.test(val.licensePlateNum)&&val.licensePlateNum) {
        // this.$message.warning("车牌号格式有误(例: 沪A12345)，请重新输入");
        val.licensePlateNum=''
        val.state = true;
      }else{
        val.state = false;
      }
    },
    blurTrailerNum(val){
      // let reg =/(^[A-Z]{1}[0-9]{4}$)/;
      //  if (!reg.test(val.trailerNum)&&val.trailerNum) {
      //   this.$message.warning("挂车车牌格式有误(例: E1234)，请重新输入");
      //   val.trailerNum = "";
      // }
    },
    // 司机姓名 中文校验
    inputChange(val) {
        let reg =/^[\u4E00-\u9FA5]{0,}$/
        if (!reg.test(val.driverName)&&val.driverName) {
          this.$message.warning("司机姓名格式有误(限中文)，请重新输入");
          val.driverName = "";
        }
    },
    // 押运员姓名中文校验
    inputChange2(val) {
        let reg =/^[\u4E00-\u9FA5]{0,}$/
        if (!reg.test(val.escortsName)&&val.escortsName) {
          this.$message.warning("押运员姓名格式有误(限中文)，请重新输入");
          val.escortsName = "";
        }
    },
    // 数量校验
    OnInput(val) {
      let twoExcess =val.arrivalAmount.indexOf(".") != -1 && val.arrivalAmount.split(".")[1].length > 2;
      if (twoExcess) {
        this.$message.warning("只保留小数点后两位");
        val.arrivalAmount = val.arrivalAmount.substr(0,val.arrivalAmount.indexOf(".") + 3);
      }
    },
    // 数量输入框失去焦点事件-调接口校验数量
    OnBlur(val) {
      let sumNum = this.multipleSelectionOrdinary.reduce((total, item) => {
        return total + Number(item.arrivalAmount);
      }, 0);

      if (sumNum > this.topData.noLadingAmount) {
        this.$message.warning("您当前编辑提单量已大于可编辑提单量，请重新输入");
        this.multipleSelectionOrdinary.forEach((item) => {
          item.arrivalAmount = "";
        });
      }
      let paramsData = {
        billLadingAmont: val.arrivalAmount,
        billLadingNum: "",
        sendPlanNum: this.pickOrArrival?this.paramsObj.arrivalPlanNum:this.paramsObj.sendPlanNum,
        status:this.pickOrArrival?'2':'1', //到货单2 提单1
      };
      this.$api.carrier.checkAmount(paramsData).then((res) => {
        // console.log(res,'提单数量校验1')
        if (res.status == 400) {
          res.msg = res.msg.replace("<B>", "");
          res.msg = res.msg.replace("</B>", "");
          this.$message.warning(res.msg);
          val.arrivalAmount = "";
        }
      });
    },
    dateBlur(val) {
      if ( this.paramsObj.planEndDate < val.billLadingDate ||val.billLadingDate < this.paramsObj.planStartDate) {
        this.$message.warning("提货起始日期必须在计划日期内！请重新输入");
        val.billLadingDate = "";
      }
    },
    deadLine(val) {
      if (val.billLadingClosingDate > this.paramsObj.planEndDate ||val.billLadingClosingDate < this.paramsObj.planStartDate ||val.billLadingClosingDate < val.billLadingDate) {
        this.$message.warning("提货截止日期必须在计划日期内并且不能早于提货起始日期！请重新输入");
        val.billLadingClosingDate = "";
      }
    },
    // 身份证校验
    idBlur(val) {
      const IDRe18 =/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const IDRe15 =/^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (!IDRe18.test(val.driverIdCardNum) &&!IDRe15.test(val.driverIdCardNum) &&val.driverIdCardNum) {
        this.$message.warning("身份证号格式有误，请重新输入");
        val.driverIdCardNum = "";
      }
    },
    // 押运员身份证号校验
    idBlur2(val) {
      const IDRe18 =/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const IDRe15 =/^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (!IDRe18.test(val.escortsIdCardNum) &&!IDRe15.test(val.escortsIdCardNum) &&val.escortsIdCardNum) {
        this.$message.warning("押运员身份证号格式有误，请重新输入");
        val.escortsIdCardNum = "";
      }
    },
    mobileBlur(val){
      const mobile=/^1[3-9]\d{9}$/
      if(!mobile.test(val.driverPhone)&&val.driverPhone){
        this.$message.warning('手机号格式有误，请重新输入')
        val.driverPhone=''
      }
    },
    // 押运员手机号
    mobileBlur2(val){
      const mobile=/^1[3-9]\d{9}$/
      if(!mobile.test(val.escortsPhone)&&val.escortsPhone){
        this.$message.warning('押运员手机号格式有误，请重新输入')
        val.escortsPhone=''
      }
    },
  },
};
</script>

<style scoped>
.total {
  font-size: 12px;
  color: #02a7f0;
  margin-left: 15px;
}
.Delivery {
  padding: 20px 25px 0; 
}
.msgRed{
    font-size: 12px;
    color: #e4260d;
    margin-left: 15px;
    padding-left: 15px;
    margin-top: 20px;
}
.iTitle{
  color: rgb(205, 6, 6);
}
::v-deep .inline-input .el-input__inner{
  border: 1px solid #e4260d;
}
/* ::v-deep .inline-input input::-webkit-input-placeholder{
  color: #e4260d !important;
  font-size: 12px !important;
} */
.inline-span{
  position: absolute;
   color: #db786b !important;
  font-size: 12px !important;
  white-space: nowrap;
  left: 20px ;
  bottom: 0;
}
::v-deep .el-table__row{
  height: 80px;
}

 .avatar-uploader-icon {
    background-color: #fff;
    font-size: 28px;
    color: #8c939d;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  ::v-deep .avatar-uploader .el-upload {
    width: 100%;
    height: 100%;
    /* width: 150px;
    height: 150px; */
  }
</style>
